import React from 'react';
import { Container } from 'components/UI/Container/Container';
import { PrismicHTMLParser } from 'components/PrismicHTMLParser';
import { Grid, GridRow, GridCol } from 'components/UI/Grid';
import { Heading } from 'components/LANDR/Heading';
import { PrismicTitleFieldType, PrismicRichTextFieldType } from '../types';
import './LogoList.scss';

type LogoListProps = {
    slice: {
        slice_type: 'logo_list';
        primary: {
            logo_list_title: PrismicTitleFieldType;
            logo_list_more_text: PrismicRichTextFieldType;
        };
        items: Array<{
            logo_list_image: {
                url: string | null;
                dimensions: {
                    width: number;
                    height: number;
                } | null;
            };
            logo_list_image_alt: PrismicRichTextFieldType;
        }>;
    };
};

class LogoList extends React.Component<LogoListProps> {
    render() {
        const { primary, items } = this.props.slice;

        const logoItems = items.map((logo, logoIndex) => {
            return (
                <GridCol colSize={`2`} mobileColSize={`6`} key={logoIndex}>
                    {/* TODO: Fix improper HTML. li must always be a direct child of a ul */}
                    <div className="LogoList-item" key={logoIndex}>
                        {/* TODO: Use Gatsby Image */}
                        {logo.logo_list_image.dimensions && (
                            <img
                                src={logo.logo_list_image.url || ''}
                                alt={logo.logo_list_image_alt.text || ''}
                                width={logo.logo_list_image.dimensions.width}
                                height={logo.logo_list_image.dimensions.height}
                            />
                        )}
                    </div>
                </GridCol>
            );
        });

        return (
            <Container className="LogoList" size="md">
                <Grid>
                    {primary.logo_list_title.raw && (
                        <Heading
                            className="LogoList-title"
                            element={primary.logo_list_title.raw[0].type}
                            size="xl"
                        >
                            {primary.logo_list_title.raw[0].text}
                        </Heading>
                    )}
                    <GridRow
                        horizontalAlign={'h-around'}
                        verticalAlign={'v-center'}
                        className="LogoList-list"
                    >
                        {logoItems}
                    </GridRow>
                    <GridRow
                        horizontalAlign={'h-around'}
                        verticalAlign={'v-center'}
                        className="LogoList-list"
                    >
                        {primary.logo_list_more_text.html && (
                            // TODO: Fix improper HTML. li must always be a direct child of a ul
                            <li className="LogoList-item">
                                <GridCol colSize={'12'}>
                                    <PrismicHTMLParser className="LogoList-moreText">
                                        {primary.logo_list_more_text.html}
                                    </PrismicHTMLParser>
                                </GridCol>
                            </li>
                        )}
                    </GridRow>
                </Grid>
            </Container>
        );
    }
}

export { LogoList, LogoListProps };
